import styled from 'styled-components';

export const ContentWrapper = styled.div`
  iframe {
    width: 660px;
    height: 368px;
    border: 0;

    @media screen and (max-width: 768px) {
      width: 100%;
      height: 50vw;
    }
  }
`;
